"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _utils = require("@material-ui/utils");
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "dataMetrics", "modifiers", "noPadding", "onRequestClose", "showArrow"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    popper: {
      '&[x-placement*="bottom"] $popperArrow': {
        '&:after': {
          borderBottomColor: 'white',
          borderTop: 'none'
        },
        '&:before': {
          borderBottomColor: 'white',
          borderTop: 'none'
        },
        height: '7px',
        top: '-7px',
        width: '14px'
      },
      '&[x-placement*="left"] $popperArrow': {
        '&:after': {
          borderLeftColor: 'white',
          borderRight: 'none'
        },
        '&:before': {
          borderLeftColor: 'white',
          borderRight: 'none'
        },
        height: '14px',
        right: '-7px',
        width: '7px'
      },
      '&[x-placement*="right"] $popperArrow': {
        '&:after': {
          borderLeft: 'none',
          borderRightColor: 'white'
        },
        '&:before': {
          borderLeft: 'none',
          borderRightColor: 'white'
        },
        height: '14px',
        left: '-7px',
        width: '7px'
      },
      '&[x-placement*="top"] $popperArrow': {
        '&:after': {
          borderBottom: 'none',
          borderTopColor: 'white'
        },
        '&:before': {
          borderBottom: 'none',
          borderTopColor: 'white'
        },
        bottom: '-7px',
        height: '7px',
        width: '14px'
      },
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 0 12px rgba(0, 0, 0, 0.5)',
      color: 'black',
      cursor: 'default',
      fontSize: '16px',
      zIndex: 10
    },
    popperArrow: function popperArrow(_ref) {
      var showArrow = _ref.showArrow;
      if (!showArrow) {
        return {
          display: 'none'
        };
      }
      return {
        '&:after': {
          border: '7px solid transparent',
          content: '""',
          height: 0,
          position: 'absolute',
          width: 0
        },
        '&:before': {
          border: '7px solid transparent',
          content: '""',
          height: 0,
          position: 'absolute',
          width: 0
        },
        position: 'absolute'
      };
    },
    popperInner: function popperInner(_ref2) {
      var noPadding = _ref2.noPadding;
      if (noPadding) {
        return {
          padding: 'none'
        };
      }
      return {
        padding: '1em'
      };
    }
  };
});
var defaultProps = {
  dataMetrics: {
    root: 'fuse_popper'
  }
};

/**
 * Use poppers when you need a non-blocking way to obtain a user response, reveal information, or show info on a precise element.
 * Poppers are non-invasive and non-blocking. The user can click away to return to their previous task.
 * Poppers should be used in cases where the interaction does not prevent other actions or process from being completed. Do not use this in place of modal.
 * If information is required it should not be in a popover.
 */
var Popper = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    className = _ref3.className,
    dataMetrics = _ref3.dataMetrics,
    _ref3$modifiers = _ref3.modifiers,
    modifiers = _ref3$modifiers === void 0 ? {} : _ref3$modifiers,
    _ref3$noPadding = _ref3.noPadding,
    noPadding = _ref3$noPadding === void 0 ? false : _ref3$noPadding,
    onRequestClose = _ref3.onRequestClose,
    _ref3$showArrow = _ref3.showArrow,
    showArrow = _ref3$showArrow === void 0 ? true : _ref3$showArrow,
    restProps = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var classes = useStyles({
    noPadding: noPadding,
    showArrow: showArrow
  });
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var popperElement = /*#__PURE__*/_react["default"].createElement(_Popper["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.popper, className),
    "data-metrics": mergedDataMetrics.root,
    modifiers: _objectSpread({
      flip: {
        enabled: false
      },
      hide: {
        enabled: false
      },
      offset: {
        enabled: true,
        offset: '0, 7'
      },
      preventOverflow: {
        enabled: true
      }
    }, modifiers),
    ref: ref
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.popperInner)
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.popperArrow),
    "x-arrow": "true"
  }));
  if (onRequestClose) {
    return /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
      onClickAway: onRequestClose
    }, popperElement);
  }
  return popperElement;
});
Popper.defaultProps = defaultProps;
Popper.displayName = 'Popper';
function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
Popper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: (0, _utils.chainPropTypes)(_propTypes["default"].oneOfType([_utils.HTMLElementType, _propTypes["default"].object, _propTypes["default"].func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
      }
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes["default"].oneOfType([_utils.HTMLElementType, _propTypes["default"].instanceOf(_react["default"].Component), _propTypes["default"].func]),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes["default"].bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: _propTypes["default"].bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: _propTypes["default"].object,
  /**
   * If true padding is removed from popper
   */
  noPadding: _propTypes["default"].bool,
  /**
   * Function called when user clicks away from popper.
   * Click away to close disabled if not provided.
   */
  onRequestClose: _propTypes["default"].func,
  /**
   * If `true`, the popper is visible.
   */
  open: _propTypes["default"].bool.isRequired,
  /**
   * Popper placement.
   */
  placement: _propTypes["default"].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: _propTypes["default"].object,
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: _utils.refType,
  /**
   * If false the arrow will be hidden.
   */
  showArrow: _propTypes["default"].bool,
  /**
   * @ignore
   */
  style: _propTypes["default"].object,
  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: _propTypes["default"].bool
} : {};
var _default = Popper;
exports["default"] = _default;